module.exports = __webpack_public_path__ + "static/media/finance-feature-2.0984959c.svg";